import { Icon, SvgForward5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function StepForwardFiveButton(props) {
  return (
    <ControlBarButton
      className={classNames('step-forward-five-button', {
        'crowded-embed': props.useEmojis && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Forward (l)"
      seeking={props.seeking}
      onClick={props.onClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgForward5 />}
      />
    </ControlBarButton>
  );
}
